import React, { useEffect, useRef, useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import Sidebar from '../StudentSidebar/Sidebar';
import StudentNavbar from '../StudentNavbar/StudentNavbar';
import RoutesPath from '../../Utils/RoutesPath';
import StudentDashboardServices from '../../Services/StudentDashboardApiService';
import { handleApiErrors } from '../../Utils/Utils';
import parse from "html-react-parser";
import ReactPlayer from 'react-player';
import { Button, Modal } from 'react-bootstrap';
import { CirclesWithBar } from 'react-loader-spinner';
import { PngImages } from '../../Utils/LocalImages';
import Image from '../../Components/Reusable/Image';
import SubmitButtonTwo from '../../Components/Reusable/Buttontwo';

// Function to extract YouTube video ID from URL

const Studytopics = () => {
    const { module_id } = useParams();
    const [topicData, setTopicData] = useState([]);
    const [topicName, setTopicName] = useState('');
    const [medium, setMedium] = useState('');
    const [subjectId, setSubjectId] = useState('');
    const [playingIndex, setPlayingIndex] = useState({ topicIndex: null, videoIndex: null });
    const playerRefs = useRef([]);
    const [showModal, setShowModal] = useState(false);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate()

    const getAllTopics = async (module_id,) => {
        setLoading(true)
        try {
            const response = await StudentDashboardServices.getAllTopics(module_id);
            if (response.topicList && response.topicList.length > 0) {
                setTopicData(response.topicList);
                setMedium(response.topicList[0].medium);
                setSubjectId(response.topicList[0].subject_id);

            } else {
                setTopicName('No topics available');
            }
        } catch (error) {
            handleApiErrors(error);
        }
        finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (module_id) {
            getAllTopics(module_id,);
        }
    }, [module_id]);

    const handlePlay = (topicIndex, videoIndex) => {
        setPlayingIndex({ topicIndex, videoIndex });
    };

    const handlePause = () => {
        setPlayingIndex({ topicIndex: null, videoIndex: null });
    };
    const handleButtonClick = () => {
        navigate(RoutesPath.studymaterials);
    };
    return (
        <div className="d-flex">
            <Sidebar />
            <div className="mainLayout-content">
                <StudentNavbar />
                <div className="main_content contentSection scroll_bar">
                    <div className="mb-3 d-flex justify-content-between align-items-center">
                        <h1 className="black fw-700 Header-student-text mb-0">Topics</h1>
                        {
                            subjectId && medium ?
                                <Link to={`${RoutesPath.studymodules}/${subjectId}/${medium}`}>
                                    <div className="d-flex">
                                        <h4 className="Caption fw-600 mb-0"><span className='orangeAccentColor'>Back</span> &gt;</h4>
                                    </div>
                                </Link> : null
                        }

                    </div>
                    {loading ? (
                        <div className="text-center d-flex justify-content-center">
                            <CirclesWithBar
                                height="80"
                                width="80"
                                color="#F6821F"
                                ariaLabel="bars-loading"
                                wrapperStyle={{}}
                                wrapperClass=""
                            />
                        </div>
                    ) : topicData.length > 0 ? (
                        topicData.map((topic, topicIndex) => (
                            <div key={topic.id}>
                                {topicIndex > 0 && (
                                    <div className="mb-3">
                                        <h1 className="black fw-700 Header-student-text mb-0 mt-5">Topics</h1>
                                    </div>
                                )}
                                <div className="mb-3">
                                    <h1 className="large-text blue fw-700 mb-0 text-capitalize">{topic.topic_name}</h1>
                                </div>
                                <div className="d-flex mb-3" style={{ borderTop: "1px solid #E4E4E4" }}></div>
                                <div className="d-flex flex-wrap gap-3 mb-3">
                                    {topic.youtube_links?.length > 0 ? (
                                        topic.youtube_links.map((item, videoIndex) => (
                                            <div key={videoIndex} className="video-wrapper" ref={el => playerRefs.current[`${topicIndex}-${videoIndex}`] = el}>
                                                <ReactPlayer
                                                    url={item}
                                                    height={170}
                                                    width={340}
                                                    style={{
                                                        borderRadius: '10px',
                                                        overflow: 'hidden'
                                                    }}
                                                    controls
                                                    playing={playingIndex.topicIndex === topicIndex && playingIndex.videoIndex === videoIndex}
                                                    onPlay={() => handlePlay(topicIndex, videoIndex)}
                                                    onPause={() => {
                                                        if (playingIndex.topicIndex === topicIndex && playingIndex.videoIndex === videoIndex) {
                                                            handlePause();
                                                        }
                                                    }}
                                                />
                                            </div>
                                        ))
                                    ) : (
                                        <p className='small-medium-text fw-600 '>No links available</p>
                                    )}
                                </div>
                                {topicIndex < topicData.length - 1 && (
                                    <div className="d-flex" style={{ borderTop: "1px solid #E4E4E4" }}></div>
                                )}
                            </div>
                        ))
                    ) : (
                        <div className="no-records-container text-center">
                            <div className="no-record-image">
                                <Image src={PngImages.no_record} className="img-fluid" />
                            </div>
                            <p className="no-records-text sub-large-text-one fw-700 mb-4">No records found</p>

                            {
                                !subjectId && !medium ?
                                    <div className="d-flex justify-content-center">
                                        <SubmitButtonTwo title={"Go to Study Materials"} className=" Package-button mb-4" onclick={handleButtonClick}></SubmitButtonTwo>
                                    </div>
                                    : null
                            }
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default Studytopics;
